import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ASSETS_BASE_URL } from "../../config";

// Accepts either a MIME type or a filename/path/URL to infer the icon.
const DocCardImage = ({ type, filename, path, url }) => {
  const { t } = useTranslation();
  const resolvedType = useMemo(() => inferType({ type, filename, path, url }), [type, filename, path, url]);
  const [imgSrc, setImgSrc] = useState(getIconForType(resolvedType));

  function inferType({ type, filename, path, url }) {
    if (type && typeof type === 'string' && type.includes('/')) return type.toLowerCase();
    const src = filename || path || url || '';
    try {
      const parsed = new URL(src);
      const pathname = parsed.pathname || '';
      const ext = pathname.split('.').pop().toLowerCase();
      return ext ? `ext:${ext}` : 'default';
    } catch {
      const s = String(src);
      const ext = s.includes('.') ? s.split('.').pop().toLowerCase() : '';
      return ext ? `ext:${ext}` : 'default';
    }
  }

  function getIconForType(t) {
    // MIME types and extensions
    switch (t) {
      case "application/pdf":
      case "ext:pdf":
        return `${ASSETS_BASE_URL}/icons/pdf.png`;

      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.ms-excel":
      case "ext:xls":
      case "ext:xlsx":
        return `${ASSETS_BASE_URL}/icons/xls.png`;

      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "ext:doc":
      case "ext:docx":
        return `${ASSETS_BASE_URL}/icons/doc.png`;

      case "image/jpeg":
      case "image/jpg":
      case "ext:jpeg":
      case "ext:jpg":
        return `${ASSETS_BASE_URL}/icons/jpg.png`;

      case "application/zip":
      case "application/x-7z-compressed":
      case "application/vnd.rar":
      case "ext:zip":
      case "ext:7z":
      case "ext:rar":
        return `${ASSETS_BASE_URL}/icons/zip.png`;

      case "image/png":
      case "ext:png":
        return `${ASSETS_BASE_URL}/icons/png.png`;

      case "image/webp":
      case "ext:webp":
      case "ext:gif":
      case "ext:bmp":
        return `${ASSETS_BASE_URL}/icons/img.png`;

      case "text/csv":
      case "ext:csv":
        return `${ASSETS_BASE_URL}/icons/csv.png`;

      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      case "ext:ppt":
      case "ext:pptx":
        return `${ASSETS_BASE_URL}/icons/ppt.png`;

      default:
        return `${ASSETS_BASE_URL}/icons/default.png`;
    }
  }

  const handleError = () => setImgSrc(`${ASSETS_BASE_URL}/icons/default.png`);

  return <img width="30" height="30" src={imgSrc} alt={t('GENERAL.DOC_ICON')} onError={handleError} />;
};

export default DocCardImage;
